import { Injectable } from "@angular/core";
import { DataService } from "../data.service";
import { StatusPaymentGateway } from "src/app/model/payment-gateway/status-payment-gateway";

@Injectable({
  providedIn: "root",
})
export class PaymentGatewayService {
  constructor(private dataService: DataService) {}

  private readonly endPoint: string = "/PaymentGateway";

  async Refund(
    cashId: number,
    transactionId: string,

    paymentAmount: number | null
  ): Promise<string> {
    const params = {
      CashId: cashId,
      TransactionId: transactionId,
      PaymentAmount: paymentAmount,
    };
    return await this.dataService
      .post<string>(`${this.endPoint}/Refund`, params)
      .toPromise();
  }

  async process(
    cashId: number,
    paymentAmount: number,
    originalPaymentAmount: number | null,
    transactionId: string | null
  ): Promise<string> {

    const params = {
      CashId: cashId,
      PaymentAmount: paymentAmount,
      OriginalPaymentAmount: originalPaymentAmount,
      TransactionId: transactionId,
    };
    return await this.dataService
      .post<string>(`${this.endPoint}/Process`, params)
      .toPromise();
  }

  async getStatus(transactionId: string): Promise<StatusPaymentGateway> {
    const params = { transactionId };
    return await this.dataService
      .get<StatusPaymentGateway>(`${this.endPoint}/GetStatus`, params)
      .toPromise();
  }
}
